var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInternalLinkArrowLeft = function SvgInternalLinkArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64.377a.667.667 0 0 0-.987 0L.205 5.13a.785.785 0 0 0 0 1.057l4.448 4.753a.667.667 0 0 0 .988 0 .784.784 0 0 0 0-1.056L2.387 6.406H12.75V4.912H2.387L5.64 1.434a.784.784 0 0 0 0-1.057"
  })));
};
export default SvgInternalLinkArrowLeft;